import type { FC } from "react";
import TagInput from "../../../components/tagInput/TagInput";
import { useUnits } from "./useUnits";

interface Props {
  readonly value: string | undefined;
  readonly onChange: (value: string) => void;
}

const UnitInput: FC<Props> = ({ value, onChange }) => {
  const { units } = useUnits();
  return (
    <TagInput
      label="Jednostka"
      tags={value ? [value] : []}
      suggestions={units}
      multiple={false}
      onChange={(v) => onChange(v.length > 0 ? v[0] : "")}
    />
  );
};

export default UnitInput;
